import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Preloader({ onDone }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const start = performance.now();
        const dur = 1900;
        let raf;
        let timer;
        const tick = (t) => {
            const p = Math.min(1, (t - start) / dur);
            setCount(Math.round(p * 100));
            if (p < 1) raf = requestAnimationFrame(tick);
            else timer = setTimeout(onDone, 500);
        };
        raf = requestAnimationFrame(tick);
        return () => {
            cancelAnimationFrame(raf);
            clearTimeout(timer);
        };
    }, [onDone]);

    return (
        <motion.div
            data-testid="preloader"
            className="fixed inset-0 z-[130] flex flex-col items-center justify-center bg-[#132B21]"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
            <motion.img
                src="/media/logo.png"
                alt="BVISION Designer Studio Logo"
                initial={{ opacity: 0, scale: 0.92, filter: "blur(12px)" }}
                animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                className="w-44 sm:w-64"
            />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                className="mt-8 font-mono text-[11px] uppercase tracking-[0.35em] text-[#A1A1AA]"
            >
                {count}%
            </motion.div>
            <div className="absolute bottom-10 left-6 right-6 h-px bg-white/10 sm:left-12 sm:right-12">
                <div className="h-full bg-[#E63946] transition-[width] duration-100" style={{ width: `${count}%` }} />
            </div>
        </motion.div>
    );
}
